(function() {
  function main() {
    document.querySelectorAll('.js-google-reviews').forEach(handleGoogleReviewSection);
  }

  function handleGoogleReviewSection(section) {
    assignTransparency([...section.querySelectorAll('.js-google-review')]);

    const left_nav = section.querySelector('.js-google-reviews-navigate-left');
    left_nav.addEventListener('click', () => {
      const reviews = [...section.querySelectorAll('.js-google-review')]
      section.appendChild(reviews[0]);

      assignTransparency([...section.querySelectorAll('.js-google-review')]);
    });

    const right_nav = section.querySelector('.js-google-reviews-navigate-right');
    right_nav.addEventListener('click', () => {
      const reviews = [...section.querySelectorAll('.js-google-review')]
      section.insertBefore(reviews[reviews.length - 1], reviews[0]);

      assignTransparency([...section.querySelectorAll('.js-google-review')]);
    });
  }

  function assignTransparency(reviews) {
    const num_reviews = reviews.length;
    let active_indexes = [];
    if (num_reviews % 2 === 0) {
      active_indexes = [
        num_reviews / 2 - 1,
        num_reviews / 2,
      ];
    } else {
      active_indexes = [
        Math.floor(num_reviews / 2) - 1,
        Math.floor(num_reviews / 2),
        Math.floor(num_reviews / 2) + 1,
      ];
    }

    reviews.forEach((review, index) => {
      if (active_indexes.includes(index)) {
        review.classList.remove('is-transparent');
        return;
      }

      review.classList.add('is-transparent');
    });
  }

  if (document.readyState === 'interactive' || document.readyState === 'complete') {
    main();
  } else {
    document.addEventListener('DOMContentLoaded', main);
  }
})();
